// src/stores/prizes.js
import { derived, writable } from 'svelte/store';
import { onSnapshot, query, where, collection } from 'firebase/firestore';
import { firestoreDb } from '$lib/firebase';
import { browser } from '$app/environment';

// Create the writable store
export const prizes = writable([]);

// Function to start listening for changes
export function subscribeToPrizes() {
  if (!browser) return () => { }; // No-op in non-browser environments

  try {
    const firestore = firestoreDb();

    // Firestore query for products where stock > 0
    const productsQuery = query(
      collection(firestore, 'products'),
      where('stock', '>', 0)
    );

    // Set up a real-time listener
    const unsubscribe = onSnapshot(
      productsQuery,
      (snapshot) => {
        const updatedPrizes = snapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          .filter(
            (prize) =>
              prize?.featured_image && prize?.featured_image !== ''
          );

        // Update the Svelte store with the live data
        prizes.set(updatedPrizes);
        // console.log('Prizes updated:', updatedPrizes); // Add logging
      },
      (error) => {
        console.error('Error fetching prizes:', error);
      }
    );

    // Return the unsubscribe function so it can be called when necessary
    return unsubscribe;
  } catch (error) {
    console.error('Error subscribing to prizes:', error);
    return () => { }; // Return a no-op function in case of error
  }
}

export const subOnlyPrizes = derived(prizes, ($prizes) => {
  if (!browser) return []; // No-op in non-browser environments
  return $prizes.filter((prize) => prize.category === 'subscriber');
});


export const allButAutoDrawPrizes = derived(prizes, ($prizes) => {
  if (!browser) return []; // No-op in non-browser environments
  return $prizes.filter((prize) => prize.category !== 'auto draw');
});
export const autoDrawPrizes = derived(prizes, ($prizes) => {
  if (!browser) return []; // No-op in non-browser environments
  return $prizes.filter((prize) => prize.category === 'auto draw');
});
